module.exports = __webpack_public_path__ + "assets/441aa32d47137c63784c2e4f5b57fcc2.mp3";